import { type FC } from 'react'

import { type SellerPromotionV2 } from '@redteclab/api/clients/bully'

import { Card, CardContent } from 'base-ui'

import {
  ProductCopyVoucherButton,
  ProductSellerVoucherLabel,
} from '../../../../../../product'

import { ProductBuyBoxVoucherInfoSellerDiscountDescription } from './ProductBuyBoxVoucherInfoSellerDiscountDescription'

const VOUCHER_SECTION_ID = 'buybox-voucher-section-discount'

export const ProductBuyBoxVoucherInfoSellerDiscount: FC<{
  sellerPromotion: SellerPromotionV2
}> = ({ sellerPromotion }: { sellerPromotion: SellerPromotionV2 }) => {
  return (
    <section aria-labelledby={VOUCHER_SECTION_ID}>
      <Card>
        <CardContent className="bg-light-primary-low p-4">
          <div className="flex flex-col gap-3">
            <span>
              <ProductSellerVoucherLabel sellerPromotion={sellerPromotion} />
            </span>
            <ProductBuyBoxVoucherInfoSellerDiscountDescription
              sellerPromotion={sellerPromotion}
            />
            {sellerPromotion.voucherCode ? (
              <ProductCopyVoucherButton voucher={sellerPromotion.voucherCode} />
            ) : null}
          </div>
        </CardContent>
      </Card>
    </section>
  )
}
